import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
let pixelLoaded = false;
export function App() {
  useEffect(() => {
    if (pixelLoaded) return;
    pixelLoaded = true;
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    window.fbq = n;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    window.fbq('init', '1254726293421119');
    window.fbq('track', 'PageView');
  }, []);
  return <LandingPage data-id="element-0" />;
}